/**
 * Workout constants - browser-safe, zero imports.
 * This is the foundation file that other workout files build upon.
 */
const workoutPlanStatuses = {
    /**
     * The use has started creating a plan but has not explicitly saved it.
     */
    DRAFT: 'draft',
    /**
     * The user has explicitly saved the plan. It's part of their main library. It's a complete plan.
     */
    ACTIVE: 'active',
    /**
     * The user has hidden the plan from their main library. but it's not deleted.
     */
    ARCHIVED: 'archived',
    /**
     * The user has deleted the plan. It's gone.
     */
    DELETED: 'deleted',
};
/**
 * Maybe later we can add more visibility options: FOLLOWERS, FRIENDS, etc.
 */
const workoutVisibilities = {
    PUBLIC: 'public',
    PRIVATE: 'private',
};
// @TODO: define how each status can be transitioned to another status
// @TODO: workoutLogStatusEnum: This is a classic state machine. The transitions would be something like:
// ongoing -> completed (User finishes successfully)
// ongoing -> abandoned (User quits)
// abandoned -> resumed -> ongoing (User comes back to a previously abandoned workout)
// This is application-level logic, but the schema supports it perfectly.
const workoutLogStatuses = {
    IN_PROGRESS: 'in_progress',
    PAUSED: 'paused',
    RESUMED: 'resumed',
    COMPLETED: 'completed',
    ABANDONED: 'abandoned',
};
export { workoutLogStatuses, workoutPlanStatuses, workoutVisibilities };
//# sourceMappingURL=workout.constants.js.map